module.exports = __webpack_public_path__ + "static/media/youtube-icon-red.d89050c6.png";